import React,{useRef} from "react";
import "./videomodal.style.css";

const VideoModal = (props) => {
  const { playVideo, setPlayVideo } = props;
  const iframRef = useRef(null);
  const closeModal = () => {
    iframRef.current.src=iframRef.current.src;
    setPlayVideo(false);
    let close = document.getElementById("modalOpen");
    close.classList.remove("mystyle");
  };
  return (
    <div
      className="pp-video-modal is-open"
      role="dialog"
      aria-label="Video Viewer"
      style={{ display: playVideo ? "block" : "none" }}
    >
      <div className="pp-video-overlay js-closeVideoModal"></div>
      <div className="pp-video-container mobile_resp_video_section">
        <div
          tabIndex={0}
          className="plyr plyr--video plyr--fullscreen-enabled plyr--captions-enabled plyr--ready plyr--stopped"
        >
          <div className="plyr__video-wrapper" style={{ cursor: "pointer" }}>
            <div className="plyr__captions">
              <span>
                We package your medication and deliver it directly to your door.
              </span>
            </div>
            <iframe
            ref={iframRef}
            className="height_iframe"
              style={{ width: "100%" }}
              height="545"
              src="https://www.youtube.com/embed/llOEpJmgVu8"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            {/* <video className="js-plyrVideo plyr--setup" controls autoPlay muted>
              <source src={video} type="video/mp4" />
            </video> */}
          </div>
        </div>
      </div>
      <button
        className="pp-video-modal-close js-closeVideoModal btn"
        onClick={closeModal}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="55.777"
          height="55.777"
          viewBox="0 0 55.777 55.777"
        >
          <g
            id="Group_690"
            data-name="Group 690"
            transform="translate(-6443.671 -1281.672)"
          >
            <line
              id="Line_8"
              data-name="Line 8"
              x2="50.12"
              y2="50.12"
              transform="translate(6446.5 1284.5)"
              fill="none"
              stroke="#919191"
              strokeLinecap="round"
              strokeWidth={4}
            />
            <line
              id="Line_9"
              data-name="Line 9"
              x1="50.12"
              y2="50.12"
              transform="translate(6446.5 1284.5)"
              fill="none"
              stroke="#919191"
              strokeLinecap="round"
              strokeWidth={4}
            />
          </g>
        </svg>
      </button>
    </div>
  );
};
export default VideoModal;
